<template>
  <div class="bpr-overlay" @click.self="$emit('close')">
    <div class="bpr-d-dialog">
      <div class="bpr-d-header">
        <div class="bpr-d-title"><i class="fa fa-rocket" aria-hidden="true"></i> スピード審査申し込み</div>
        <button class="bpr-d-close" @click="$emit('close')">✕</button>
      </div>

      <div class="bpr-d-body">
        <div class="bpr-f-speed-wrap">
          <div class="speed-compare">
            <div class="compare-main">
              <span class="cmp-pill normal">通常審査</span>
              <div class="cmp-num normal-num">
                <span class="pre">約</span><span class="big">20</span><span class="unit">日</span>
              </div>
              <span class="cmp-sub normal-sub">で審査完了</span>

              <div class="cmp-arrow">
                <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <line x1="0" y1="9" x2="25" y2="9" stroke="#555" stroke-width="1.5" stroke-linecap="round"/>
                  <polyline points="18,0 26,9 18,18" stroke="#555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>

              <span class="cmp-pill speed">スピード審査</span>
              <div class="cmp-num blue speed-num">
                <span class="pre">最短</span><span class="big">7</span><span class="unit">営業日</span>
              </div>
              <span class="cmp-sub speed-sub">で審査完了</span>
            </div>

            <div class="premium-box">
              <div class="prem-header">
                <img src="/static/images/crown.png" alt="" aria-hidden="true" style="width:20px;height:17px;object-fit:contain;flex-shrink:0;vertical-align:middle">
                セルモンプレミアムなら
              </div>
              <div class="prem-num">
                <span class="pre">最短</span><span class="big">3</span><span class="unit">営業日</span>
              </div>
              <div class="prem-sub">で審査完了</div>
              <router-link to="/setting/plan-info" class="prem-link">詳しくはこちら <span style="font-size:16px;line-height:1">›</span></router-link>
            </div>
          </div>
        </div>

        <p class="bpr-f-apply-note">選択した商品をスピード審査の対象として申し込みます。</p>

        <div class="bpr-d-asin-static">
          <div class="bpr-d-asin-label">対象商品（ASIN）</div>
        </div>
        <div class="bpr-d-chip-section">
          <div class="bpr-d-asin-list-wrap">
            <div ref="fAsinList" :class="['bpr-d-asin-list', showAllChipsF ? 'bpr-d-asin-list--expanded' : '']">
              <span v-for="(item, idx) in localItemsF" :key="item.asin" class="bpr-d-asin-chip">
                <span>{{ item.asin }}</span>
                <button class="bpr-d-asin-remove" @click="removeItemF(idx)" title="削除">✕</button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showLoadMoreF" class="bpr-d-loadmore-wrap">
        <button class="bpr-load-more bpr-d-load-more" @click="toggleChipsF">
          <span v-if="!showAllChipsF">もっと見る（残り{{ hiddenCountF }}件以上）<i class="fa fa-chevron-down"></i></span>
          <span v-else>閉じる <i class="fa fa-chevron-up"></i></span>
        </button>
      </div>

      <div class="bpr-d-static-bottom bpr-f-static-bottom">
        <div class="bpr-f-calc-box">
          <div class="bpr-f-calc-section">
            <div class="bpr-f-calc-caption">対象商品</div>
            <div class="bpr-f-calc-price">{{ localItemsF.length }}</div>
          </div>
          <div class="bpr-f-calc-operator">×</div>
          <div class="bpr-f-calc-section">
            <div class="bpr-f-calc-caption">1商品あたり</div>
            <div class="bpr-f-calc-price">
              <template v-if="priceAvailable">¥{{ price.toLocaleString() }}<span class="bpr-f-calc-tax-ex">（税抜）</span></template>
              <template v-else>¥―<span class="bpr-f-calc-tax-ex">（税抜）</span></template>
            </div>
            <div class="bpr-f-calc-tax-in">
              <template v-if="priceAvailable">¥{{ fItemPriceTaxIn.toLocaleString() }}（税込）</template>
              <template v-else>¥―（税込）</template>
            </div>
          </div>
          <div class="bpr-f-calc-operator">=</div>
          <div class="bpr-f-calc-section bpr-f-calc-section--total">
            <div class="bpr-f-calc-caption">合計</div>
            <div class="bpr-f-calc-price">
              <template v-if="priceAvailable">¥{{ fTotalPriceTaxEx.toLocaleString() }}<span class="bpr-f-calc-tax-ex">（税抜）</span></template>
              <template v-else>¥―<span class="bpr-f-calc-tax-ex">（税抜）</span></template>
            </div>
            <div class="bpr-f-calc-tax-in">
              <template v-if="priceAvailable">¥{{ fTotalPriceTaxIn.toLocaleString() }}（税込）</template>
              <template v-else>¥―（税込）</template>
            </div>
          </div>
        </div>
      </div>

      <p class="bpr-f-notice">※「スピード審査を申し込む」を押すと、Stripeの決済画面へ移動します。</p>

      <div class="bpr-d-footer">
        <button class="bpr-d-btn bpr-d-btn-cancel" @click="$emit('close')">キャンセル</button>
        <button class="bpr-d-btn bpr-d-btn-primary" :disabled="loading || localItemsF.length === 0 || !priceAvailable" @click="handlePurchaseF">
          <span v-if="loading" class="bpr-spinner"></span>
          <span v-else>スピード審査を申し込む（{{ localItemsF.length }}点）</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const TAX_RATE = 1.1

export default {
  name: 'BulkPriorityReviewModal',
  props: {
    eligibleItems: { type: Array, default: () => [] },
    price: { type: Number, default: null },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      showAllChipsF: false,
      localItemsF: [],
      showLoadMoreF: false,
      hiddenCountF: 0
    }
  },
  created () {
    this.localItemsF = [...this.eligibleItems]
  },
  mounted () {
    this.$nextTick(this._checkRowsF)
  },
  computed: {
    priceAvailable () {
      return this.price !== null && this.price !== undefined
    },
    fItemPriceTaxIn () {
      return Math.round(this.price * TAX_RATE)
    },
    fTotalPriceTaxEx () {
      return this.localItemsF.length * this.price
    },
    fTotalPriceTaxIn () {
      return Math.round(this.localItemsF.length * this.price * TAX_RATE)
    }
  },
  watch: {
    eligibleItems (val) {
      this.showAllChipsF = false
      this.localItemsF = [...val]
      this.$nextTick(this._checkRowsF)
    }
  },
  methods: {
    _checkRowsF () {
      const el = this.$refs.fAsinList
      if (!el) return
      const chips = Array.from(el.children)
      if (!chips.length) { this.showLoadMoreF = false; return }
      const rows = []
      chips.forEach(chip => {
        const top = chip.offsetTop
        let row = rows.find(r => r.top === top)
        if (!row) { row = { top, items: 0 }; rows.push(row) }
        row.items++
      })
      rows.sort((a, b) => a.top - b.top)
      if (rows.length > 3) {
        this.showLoadMoreF = true
        this.hiddenCountF = rows.slice(3).reduce((s, r) => s + r.items, 0)
      } else {
        this.showLoadMoreF = false
        this.hiddenCountF = 0
      }
    },
    removeItemF (idx) {
      this.localItemsF.splice(idx, 1)
      this.$nextTick(this._checkRowsF)
    },
    handlePurchaseF () {
      this.$emit('purchase', this.localItemsF)
    },
    toggleChipsF () {
      const wasExpanded = this.showAllChipsF
      this.showAllChipsF = !wasExpanded
      if (wasExpanded && this.$refs.fAsinList) {
        this.$refs.fAsinList.scrollTop = 0
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700;900&display=swap');
/* ─── Shared ─── */
.bpr-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  font-family: 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
}
@keyframes bpr-in {
  from { transform: translateY(-12px); opacity: 0; }
  to   { transform: translateY(0);     opacity: 1; }
}
.bpr-spinner {
  display: inline-block;
  width: 16px; height: 16px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: bpr-spin 0.7s linear infinite;
  vertical-align: middle;
}
@keyframes bpr-spin { to { transform: rotate(360deg); } }

.bpr-load-more {
  display: block;
  width: 100%;
  margin-top: 8px;
  background: none;
  border: 1px dashed #b8ddf0;
  border-radius: 3px;
  color: #008cc6;
  font-size: 12px;
  padding: 5px 8px;
  cursor: pointer;
  text-align: center;
  transition: background 0.12s;
}
.bpr-load-more:hover { background: #f0f9ff; }

/* ─── Dialog shell (shared with AddByAmazonPurchaseModal layout) ─── */
.bpr-d-dialog {
  font-family: 'Noto Sans JP', 'Hiragino Sans', 'Yu Gothic UI', system-ui, sans-serif;
  background: #fff;
  border-radius: 6px;
  width: 583px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,.35);
  overflow: hidden;
  animation: bpr-in 0.18s ease;
}
.bpr-d-header {
  background: #1e88c7;
  color: #fff;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.bpr-d-title { font-size: 15px; font-weight: 700; flex: 1; }
.bpr-d-close {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  opacity: 0.9;
  line-height: 1;
  padding: 4px;
}
.bpr-d-close:hover { opacity: 1; }

.bpr-d-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.bpr-d-asin-static {
  flex-shrink: 0;
  padding: 0 20px 0;
}

.bpr-d-chip-section {
  flex-shrink: 0;
  padding: 8px 20px 0;
  min-width: 0;
}

.bpr-d-loadmore-wrap {
  flex-shrink: 0;
  padding: 0 20px 8px;
}

.bpr-d-static-bottom {
  flex-shrink: 0;
  padding: 16px 20px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ASIN chips */
.bpr-d-asin-label { font-size: 12px; color: #586170; font-weight: 700; margin-bottom: -7px; }
.bpr-d-asin-list-wrap { position: relative; }
.bpr-d-asin-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 8px 8px 0 0;
  max-height: 122px;
  overflow: hidden;
}
.bpr-d-asin-list--expanded {
  max-height: none;
  overflow: visible;
}
.bpr-d-asin-chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eaf5fb;
  border: 1px solid #d8e8f0;
  color: #1a75ab;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 4px;
  font-family: monospace;
}
.bpr-d-asin-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  border: 1px solid #fff;
  background: #b9c4cd;
  color: #fff;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 9px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,.2);
}
.bpr-d-asin-remove:hover { background: #e74c3c; }

/* Speed box */
.bpr-d-speed-box {
  background: #eaf5fb;
  border: 1px solid #d8e8f0;
  border-radius: 6px;
  padding: 16px 18px;
  position: relative;
}
.bpr-d-max-days {
  position: absolute;
  top: -11px;
  right: 14px;
  background: #1e88c7;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 12px;
}
.bpr-d-speed-cols { display: flex; align-items: baseline; justify-content: center; gap: 14px; }
.bpr-d-speed-col { text-align: center; }
.bpr-d-speed-old { font-size: 26px; font-weight: 700; color: #b9c4cd; }
.bpr-d-speed-old-label { font-size: 11px; color: #8a97a3; display: block; text-align: center; margin-top: 2px; }
.bpr-d-arrow { font-size: 20px; color: #8a97a3; }
.bpr-d-speed-new { font-size: 30px; font-weight: 800; color: #1e88c7; }
.bpr-d-speed-new-label { font-size: 11px; color: #1a75ab; font-weight: 600; display: block; text-align: center; margin-top: 2px; }

/* Footer */
.bpr-d-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 20px 22px;
  flex-shrink: 0;
}
.bpr-d-btn {
  border: none;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 20px;
  cursor: pointer;
  font-family: inherit;
}
.bpr-d-btn-cancel {
  background: #fff;
  border: 1px solid #c7d2d9;
  color: #5a6570;
}
.bpr-d-btn-cancel:hover { background: #f5f7f8; }
.bpr-d-btn-primary {
  background: #1e88c7;
  color: #fff;
}
.bpr-d-btn-primary:hover:not(:disabled) { background: #1a75ab; }
.bpr-d-btn-primary:disabled { background: #b9c4cd; cursor: not-allowed; }

/* ─── Variant F overrides ─── */
.bpr-f-speed-wrap {
  padding: 16px 20px 0;
  display: flex;
  justify-content: center;
}
.speed-compare {
  display: flex;
  gap: 10px;
  align-items: stretch;
  max-width: 560px;
  width: 100%;
}
.compare-main {
  flex: 1;
  background: #F0F6FA;
  border-radius: 8px;
  padding: 15px 10px;
  display: grid;
  grid-template-columns: 1fr 20px 1fr;
  grid-template-rows: auto auto auto;
  align-items: center;
  row-gap: 5px;
}
.cmp-pill {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 20px;
  border-radius: 20px;
  white-space: nowrap;
  line-height: 1.5;
  justify-self: center;
}
.cmp-pill.normal {
  grid-area: 1 / 1;
  background: #D5E0EB;
  color: #636c78;
  border: 1.5px solid #D4E4F0;
}
.cmp-pill.speed {
  grid-area: 1 / 3;
  background: #1C7ED6;
  color: #fff;
}
.cmp-num {
  display: flex;
  align-items: baseline;
  gap: 1px;
  line-height: 1;
  justify-self: center;
}
.cmp-num.normal-num { grid-area: 2 / 1; color: #636c78; }
.cmp-num.speed-num  { grid-area: 2 / 3; }
.cmp-num .pre  { font-size: 19px; font-weight: 700; }
.cmp-num .big  { font-size: 48px; font-weight: 900; font-variant-numeric: tabular-nums; line-height: .95; }
.cmp-num .unit { font-size: 22px; font-weight: 700; }
.cmp-num.blue .big  { color: #1C7ED6; }
.cmp-num.blue .pre  { color: #1C7ED6; font-weight: 700; font-size: 22px; }
.cmp-num.blue .unit { color: #1C7ED6; font-size: 28px; }
.cmp-sub {
  font-size: 13px;
  color: #555;
  justify-self: center;
  font-weight: 500;
}
.cmp-sub.normal-sub { grid-area: 3 / 1; }
.cmp-sub.speed-sub  { grid-area: 3 / 3; color: #1C7ED6; font-weight: 700; }
.cmp-arrow {
  grid-area: 2 / 2;
  font-size: 20px;
  color: #1A1A1A;
  justify-self: center;
  align-self: center;
  margin: 16px 19px 0 0;
}
.premium-box {
  width: 170px;
  flex-shrink: 0;
  background: #fcf9ea;
  border: 1.5px solid #f6da8b;
  border-radius: 8px;
  padding: 11px 12px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}
.prem-header {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #A07A00;
  white-space: nowrap;
}
.prem-num {
  display: flex;
  align-items: baseline;
  gap: 1px;
  line-height: 1;
  margin-top: 2px;
}
.prem-num .pre  { font-size: 17px; font-weight: 700; color: #E8A000; margin-right: 5px; }
.prem-num .big  { font-size: 36px; font-weight: 900; color: #E8A000; font-variant-numeric: tabular-nums; line-height: .95; margin-right: 5px; }
.prem-num .unit { font-size: 21px; font-weight: 700; color: #E8A000; }
.prem-sub { font-size: 12px; color: #A07A00; font-weight: 500; }
.prem-link {
  display: inline-block;
  margin-top: 5px;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  background-color: #fdf1cb;
  border-radius: 4px;
  padding: 4px 10px;
  width: 100%;
  text-align: center;
  color: #A07A00;
  transition: background .18s, box-shadow .18s, transform .18s, color .18s;
}
.prem-link:hover {
  background: #fbe89e;
  color: #7a5c00;
  box-shadow: 0 2px 8px rgba(232,160,0,.28);
  transform: translateY(-1px);
}
.bpr-f-notice {
  font-size: 13px;
  color: var(--text-muted, #888);
  padding: 0 20px 0;
  margin: 0;
}
.bpr-f-apply-note {
  font-size: 13px;
  color: #7b818d;
  line-height: 1.65;
  text-align: left;
  padding: 15px 20px;
  margin: 0;
}
.bpr-f-static-bottom {
  padding-top: 8px;
}
.bpr-f-calc-box {
  border: none;
  border-radius: 8px;
  background: #f4fafd;
  padding: 12px 10px;
  display: flex;
  justify-content: space-around;
  gap: 16px;
  align-items: flex-start;
}
.bpr-f-calc-section { text-align: left; }
.bpr-f-calc-section:first-child { text-align: center; }
.bpr-f-calc-section--total { text-align: right; }
.bpr-f-calc-operator { font-size: 26px; font-weight: 600; color: #90a4b0; margin-top: 26px; line-height: 38px; }
.bpr-f-calc-caption { font-size: 13px; color: #8a97a3; margin-bottom: 10px; white-space: nowrap; }
.bpr-f-calc-price { font-size: 30px; font-weight: 800; color: #1e88c7; line-height: 1; }.bpr-f-calc-tax-ex { font-size: 12px; font-weight: 400; color: #8a97a3; }
.bpr-f-calc-tax-in { font-size: 12px; color: #8a97a3; margin-top: 4px; }
</style>



// WEBPACK FOOTER //
// src/view/productsNew/BulkPriorityReviewModal.vue